import React, { useState } from "react";
import { personal } from "../data";

function LinkRow({ label, href }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textDecoration: "none",
        padding: "0.9rem 0",
        borderBottom: `0.5px solid ${hovered ? "#6d9aa4" : "rgba(100,98,92,0.15)"}`,
        transition: "border-color 0.2s",
      }}
    >
      <span
        style={{
          fontSize: "12px",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: hovered ? "#3d6e78" : "#6b6963",
          transition: "color 0.2s",
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: "14px",
          color: "#9b9991",
          transform: hovered ? "translate(3px, -3px)" : "translate(0,0)",
          transition: "transform 0.2s",
          display: "inline-block",
        }}
      >
        ↗
      </span>
    </a>
  );
}

function FormInput({ label, type = "text", placeholder, multiline }) {
  const shared = {
    background: "transparent",
    border: "none",
    borderBottom: "0.5px solid #cccac3",
    padding: "8px 0",
    fontFamily: "'DM Mono', monospace",
    fontSize: "13px",
    color: "#2e2d2a",
    outline: "none",
    width: "100%",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <label
        style={{
          fontSize: "10px",
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "#9b9991",
        }}
      >
        {label}
      </label>
      {multiline ? (
        <textarea
          placeholder={placeholder}
          rows={4}
          style={{ ...shared, resize: "none", lineHeight: 1.6 }}
          onFocus={(e) => (e.target.style.borderBottomColor = "#6d9aa4")}
          onBlur={(e) => (e.target.style.borderBottomColor = "#cccac3")}
        />
      ) : (
        <input
          type={type}
          placeholder={placeholder}
          style={shared}
          onFocus={(e) => (e.target.style.borderBottomColor = "#6d9aa4")}
          onBlur={(e) => (e.target.style.borderBottomColor = "#cccac3")}
        />
      )}
    </div>
  );
}

export default function Contact() {
  const [sent, setSent] = useState(false);

  return (
    <section
      id="contact"
      style={{
        padding: "6rem 2.5rem",
        maxWidth: "900px",
        margin: "0 auto",
        fontFamily: "'DM Mono', monospace",
      }}
    >
      <div
        style={{
          fontSize: "10px",
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "#9b9991",
          marginBottom: "3rem",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        Contact
        <span
          style={{
            flex: 1,
            height: "0.5px",
            background: "rgba(100,98,92,0.15)",
            maxWidth: "60px",
          }}
        />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "4rem",
          alignItems: "start",
        }}
      >
        {/* Left */}
        <div>
          <h2
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: "36px",
              fontWeight: 300,
              fontStyle: "italic",
              color: "#2e2d2a",
              lineHeight: 1.2,
              marginBottom: "1.5rem",
            }}
          >
            Let's work
            <br />
            together.
          </h2>
          <p
            style={{
              fontSize: "12px",
              color: "#6b6963",
              lineHeight: 1.8,
              letterSpacing: "0.03em",
            }}
          >
            Open to full-time roles, contract work, and interesting
            conversations.
          </p>

          <div style={{ marginTop: "2.5rem" }}>
            {personal.links.github && (
              <LinkRow label="GitHub" href={personal.links.github} />
            )}
            {personal.links.linkedin && (
              <LinkRow label="LinkedIn" href={personal.links.linkedin} />
            )}
            {personal.links.resume && (
              <LinkRow label="Resume" href={personal.links.resume} />
            )}
            {personal.links.cv && (
              <LinkRow label="CV" href={personal.links.cv} />
            )}
          </div>
        </div>

        {/* connect to formspree or email.js later */}
        <form
          style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
        >
          <FormInput label="Name" placeholder="Your name" />
          <FormInput label="Email" type="email" placeholder="you@example.com" />
          <FormInput
            label="Message"
            placeholder="What are you building?"
            multiline
          />

          <button
            type="submit"
            style={{
              alignSelf: "flex-start",
              background: sent ? "#6b6963" : "#3d6e78",
              color: "#dde6e8",
              border: "none",
              padding: "10px 28px",
              fontFamily: "'DM Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              cursor: sent ? "default" : "pointer",
              borderRadius: "2px",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => {
              if (!sent) e.target.style.background = "#2e2d2a";
            }}
            onMouseLeave={(e) => {
              if (!sent) e.target.style.background = "#3d6e78";
            }}
          >
            {sent ? "Message sent" : "Send message"}
          </button>
          <p style={{ fontSize: "11px", color: "#9b9991", lineHeight: 1.6 }}>
            {/* replace the onSubmit handler above with a Formspree / EmailJS call */}
            {/* Or email directly: <a href={`mailto:${personal.links.email}`}
                                              style={{color: '#3d6e78'}}>{personal.links.email}</a> */}
          </p>
        </form>
      </div>
    </section>
  );
}
